import React from "react";
import polaroid from "../../assets/img/footer/polaroid.png";
import logo from "../../assets/img/footer/logo.png";
import download from "../../assets/img/footer/download.png";
import "./footer.css";
import { Link } from "react-router-dom";
import Plaquette from "../../assets/documents/Plaquette.pdf";

// 1️⃣ Import des icônes
import {
  FaEnvelope,
  FaPhone,
  FaGlobe,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

export default function App() {
  // 2️⃣ Tes liens avec icônes injectées
  const link = [
    {
      ico: <FaEnvelope className="link-list__icon" />,
      text1: "admin@azureaprintsolutions.com",
      link1: "mailto:admin@azureaprintsolutions.com",
    },
    {
      ico: <FaPhone className="link-list__icon" />,
      text1: "04 65 84 85 54",
      text2: "06 99 03 69 49",
      link1: "tel:+33465848554",
      link2: "tel:+33699036949",
    },
    {
      ico: <FaGlobe className="link-list__icon" />,
      text1: "www.azureaprintsolutions.com",
      link1: "https://www.azureaprintsolutions.com",
    },
    {
      ico: <FaMapMarkerAlt className="link-list__icon" />,
      text1: "233 routes de Cannes - 06130 Grasse",
      link1: "https://maps.app.goo.gl/h4VC6pa1zbhEZ8Qq8",
    },
  ];

  // 3️⃣ Tes réseaux sociaux
  const socials = [
    {
      ico: <FaInstagram className="link-list__icon" />,
      href: "https://www.instagram.com/aps06130/",
    },
    {
      ico: <FaFacebookF className="link-list__icon" />,
      href: "https://www.facebook.com/people/Azurea-Print-Solutions/61569368392467/",
    },
    {
      ico: <FaLinkedinIn className="link-list__icon" />,
      href: "https://fr.linkedin.com/company/azurea-print-solutions",
    },
  ];

  return (
    <footer className="Footer">
      <div className="Footer__polaroid">
        <p>Notre mascotte digitale : DOLPHY !</p>
        <img src={polaroid} alt="" />
      </div>

      <li className="Footer__logo">
        <img src={logo} alt="" />
        <div>
          <p>
            Télécharger
            <br /> la plaquette :
          </p>
          <a href={Plaquette} download="Plaquette.pdf">
            <img src={download} alt="" />
          </a>
        </div>
      </li>

      <li className="Footer__links">
        <article className="link-list">
          {link.map(({ ico, text1, text2, link1, link2 }, idx) => (
            <li key={idx} className="link-list__item">
              <span className="link-list__icon">{ico}</span>
              <div>
                <a href={link1} target="_blank" className="link-list__text">
                  {text1}
                </a>
                <a href={link2} target="_blank" className="link-list__text">
                  {text2}
                </a>
              </div>
            </li>
          ))}
        </article>

        <li>
          <p className="blue">Retrouvez nous sur :</p>
          <div className="social-list">
            {socials.map(({ ico, href }, idx) => (
              <a key={idx} href={href} target="_blank">
                <span className="link-list__icon">{ico}</span>
              </a>
            ))}
          </div>
        </li>
      </li>

      <li className="Footer__legal">
        <p>
          <Link to={"/mentions-legales"} className="blue underline">
            Mentions légales
          </Link>
          <br />& Cookies
        </p>
        <p>
          <span className="blue">Copyright</span>
          <br /> Azurea Print & Solutions Photos : Adobestock et Pexels
        </p>
        <p>
          Made with 💙 by{" "}
          <a
            className="link-list__text underline"
            href="https://maelcorp.com/"
            target="_blank"
          >
            MaelCorp.
          </a>
        </p>
      </li>
    </footer>
  );
}
